import { safeHTML } from '../../../../utils/safeHTML'
import { getCurrentMonthLastDay, convertDateFormat } from '../../../../utils/helpers/helpers'
import CustomButton from '../../../features/customButton/ui/main/CustomButton'
import { OLD_RATING } from '../../../../constants/shared/states/names'
import React from 'react'
import { useTranslation, conturs, defaultContur } from '../../../../translations'
import classNames from 'classnames'
import useMonthName from '../../../../hooks/shared/date/useMonthName'
import { useLanguageControls } from '../../../../hooks/useLanguageControls'
import useStateControls from '../../../../hooks/useStateControls'
import { rating as ratingData } from '../../../../constants/copyright'

const { reward } = ratingData

export default function RatingInfo({ ratingInfo, range }) {
  const monthName = useMonthName()
  const { t, i18n } = useTranslation()
  const { getLocalizedText } = useLanguageControls()
  const { setState } = useStateControls()

  const startDate = ratingInfo?.activeRatings?.date?.split('-')[0] ?? ''
  const endDate = ratingInfo?.activeRatings?.date?.split('-')[1] ?? ''
  const monthEndDate = getCurrentMonthLastDay()

  const formattedStartDate = convertDateFormat(startDate, i18n.language)
  const formattedEndDate = convertDateFormat(endDate, i18n.language)
  const formattedMonthEndDate = convertDateFormat(monthEndDate, i18n.language)
  const formattedMonthEndDateFixed = '26.04'

  const targetDate = new Date('2026-01-01') // TODO: убрать проверку после окончания 1 месяца ME
  const isMeContur = defaultContur === conturs.me
  const isAfterTargetDate = new Date() >= targetDate

  // Кнопка:
  // - для недели: показывается всегда
  // - для месяца: показывается если не ME контур или дата >= targetDate
  const shouldShowButton = range === 'week' ? true : !isMeContur || isAfterTargetDate

  return (
    <div className={classNames('games__rating-box', 'games__rating-box_rating')}>
      <p className={'games__rating-box-date'}>
        {safeHTML(
          {
            week: t('rating.date.week.new', {
              start: formattedStartDate,
              end: formattedEndDate,
            }),
            month: t('rating.date.month', { end: formattedMonthEndDateFixed }),
          }[range],
        )}
      </p>

      <p className={'games__rating-box-text'}>
        {safeHTML(
          {
            week: getLocalizedText(
              t('rating.text.new', {
                returnObjects: true,
                firstPlace: reward(t).firstPlace,
                secondToFifthPlace: reward(t).secondToFifthPlace,
                sixthToTenthPlace: reward(t).sixthToTenthPlace,
                eleventhToTwentiethPlace: reward(t).eleventhToTwentiethPlace,
              }),
            ),
            month: monthName,
          }[range],
        )}
      </p>

      {shouldShowButton && (
        <CustomButton
          text={t('rating.buttonText')}
          className={classNames('custom-button_games-rating', 'rating__transition-button')}
          onClick={() => setState(OLD_RATING)}
        />
      )}
    </div>
  )
}
